import React, { useRef, useState } from 'react';
import { Box, styled, TextField, Typography } from '@mui/material';
import PrimaryBtn from '../shared/Buttons/PrimaryButton';
import { useTranslation } from 'react-i18next';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { Variant } from '../../models/Product';
import { QuantitySelector } from '../shared/QuantitySelector';

const StyledWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    gap: '10px',
    [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
    },
}));

const SubmitContainer = styled('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    padding: 0,
    button: {
        minHeight: '50px',
        width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
        paddingTop: '10px',
    },
}));

export const ProductAddTo = (props: { variant: Variant }) => {
    const variant = props.variant;
    const { t } = useTranslation('product');
    const [qty, setQty] = useState(1);

    const handleChange = (qty: number) => {
        setQty(qty);
    };

    return (
        <StyledWrapper>
            <Box>
                <Typography paragraph sx={{ fontWeight: 'bold' }}>
                    {t('PRODUCT.QTY')}:
                </Typography>
                <QuantitySelector variant={variant} qtyChanged={handleChange} />
            </Box>
            <SubmitContainer>
                <PrimaryBtn>{t('PRODUCT.ADD_TO')}</PrimaryBtn>
            </SubmitContainer>
        </StyledWrapper>
    );
};
